import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2abb0f3e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2abb0f3e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2abb0f3e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2abb0f3e')) {
      api.createRecord('2abb0f3e', component.options)
    } else {
      api.reload('2abb0f3e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2abb0f3e&scoped=true", function () {
      api.rerender('2abb0f3e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pattern/components/preset-one-button-manage/index.vue"
export default component.exports